module.exports = __webpack_public_path__ + "img/sticker-ru50x50.242a24a4.jpg";